import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=62836732&"
import script from "./SidebarLink.vue?vue&type=script&lang=js&"
export * from "./SidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports